import { NavigationHeaderContext } from "./NavigationHeaderContext";
import { generateRandomStr } from "../utils";
import cx from 'classnames';
import { isUndefined } from 'lodash-es';
import React, { useCallback, useContext } from 'react';
var HeaderNavItem = function HeaderNavItem() {
  var NavigationHeaderContextProps = useContext(NavigationHeaderContext);
  var navItemComponent = NavigationHeaderContextProps.navItemComponent,
    _NavigationHeaderCont = NavigationHeaderContextProps.navItem,
    navItem = _NavigationHeaderCont === void 0 ? [{
      label: '首页',
      href: 'https://home.fanruan.com/'
    }, {
      label: '服务平台',
      href: 'https://home.fanruan.com/service'
    }, {
      label: '文档',
      href: 'https://help.fanruan.com/'
    }, {
      label: '学院',
      href: 'https://edu.fanruan.com/'
    }, {
      label: '问答',
      href: 'https://bbs.fanruan.com/wenda'
    }, {
      label: '论坛',
      href: 'https://bbs.fanruan.com/topic'
    }, {
      label: '认证',
      href: 'https://cert.fanruan.com/'
    }, {
      label: '招聘',
      href: 'https://bbs.fanruan.com/jobs'
    }, {
      label: '任务',
      href: 'https://bbs.fanruan.com/task'
    }, {
      label: '市场',
      href: 'https://market.fanruan.com/'
    }] : _NavigationHeaderCont;
  var pathname = window.location.pathname;
  var href = window.location.href;
  var calcIsActive = useCallback(function (item) {
    var judgeType = item.type || 'href';
    var judgeUrl = judgeType === 'pathname' ? pathname : href;
    if (item.isExact) {
      return judgeUrl === item.href;
    } else {
      return judgeUrl.indexOf(item.href) > -1;
    }
  }, [pathname]);
  return /*#__PURE__*/React.createElement("div", {
    className: "dr-nav-item-wrapper"
  }, isUndefined(navItemComponent) ? navItem.map(function (item) {
    var isActive = function isActive() {
      if (isUndefined(item.isActive)) {
        return calcIsActive(item);
      }
      return item.isActive;
    };
    return /*#__PURE__*/React.createElement("a", {
      href: item.href,
      className: cx('dr-nav-item', isActive() && 'active'),
      key: generateRandomStr(),
      rel: "noreferrer"
    }, item.label);
  }) : navItemComponent);
};
export default HeaderNavItem;